var map = {
	"./building/building-25.svg": "4bdb",
	"./contract/contract-25.svg": "eed6",
	"./document/document-25.svg": "3cf7",
	"./facility/facility-25.svg": "308d",
	"./role/role-25.svg": "c556"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffdf";